module.exports = __webpack_public_path__ + "img/TV_clean_box26.64b12c42.jpg";